import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = (): any => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when pathname changes
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
